import { Dispatcher as FluxDispatcher } from 'flux';
import ACTION_TYPES from './constants/action_types';
import { logDispatch } from '../_modules/logging/logger';

class DispatcherClass extends FluxDispatcher {
  dispatch(action) {
    super.dispatch(action);
    logDispatch(action.action.type, action.action.payload);
  }

  handleStationsAction(action) {
    this.dispatch({
      source: ACTION_TYPES.STATION_LIST_ACTION,
      action,
    });
  }

  handleActiveStationsAction(action) {
    this.dispatch({
      source: ACTION_TYPES.ACTIVE_STATION_ACTION,
      action,
    });
  }

  handleLightboxAction(action) {
    this.dispatch({
      source: ACTION_TYPES.LIGHTBOX_ACTION,
      action,
    });
  }

  handleMapAction(action) {
    this.dispatch({
      source: ACTION_TYPES.MAP_ACTION,
      action,
    });
  }

  handleTyreAction(action) {
    this.dispatch({
      source: ACTION_TYPES.TYRE_ACTION,
      action,
    });
  }

  handleVehicleSelectorAction(action) {
    this.dispatch({
      source: ACTION_TYPES.VEHICLE_SELECTOR_ACTION,
      action,
    });
  }

  handleTranslationAction(action) {
    this.dispatch({
      source: ACTION_TYPES.TRANSLATION_ACTION,
      action,
    });
  }

  handleConfiguratorAction(action) {
    this.dispatch({
      source: ACTION_TYPES.CONFIGURATOR_ACTION,
      action,
    });
  }

  handleCartAction(action) {
    this.dispatch({
      source: ACTION_TYPES.CART_ACTION,
      action,
    });
  }

  handlePostcodeAction(action) {
    this.dispatch({
      source: ACTION_TYPES.POSTCODE_ACTION,
      action,
    });
  }

  handlePostcodeLightBoxAction(action) {
    this.dispatch({
      source: ACTION_TYPES.POSTCODE_LIGHT_BOX_ACTION,
      action,
    });
  }

  handleCatalogFilterAction(action) {
    this.dispatch({
      source: ACTION_TYPES.CATALOG_FILTER_ACTION,
      action,
    });
  }

  handleCatalogConfiguratorAction(action) {
    this.dispatch({
      source: ACTION_TYPES.CATALOG_CONFIGURATOR_ACTION,
      action,
    });
  }

  handleVehicleConfiguratorAction(action) {
    this.dispatch({
      source: ACTION_TYPES.VEHICLE_CONFIGURATOR_ACTION,
      action,
    });
  }

  handleRegoLookupAction(action) {
    this.dispatch({
      source: ACTION_TYPES.REGO_LOOKUP_ACTION,
      action,
    });
  }

  handleFilterOptionsAction(action) {
    this.dispatch({
      source: ACTION_TYPES.FILTER_OPTIONS_ACTION,
      action,
    });
  }

  handleTyreSizeConfiguratorFilterOptionsAction(action) {
    this.dispatch({
      source: ACTION_TYPES.TYRE_SIZE_CONFIGURATOR_FILTER_OPTIONS_ACTION,
      action,
    });
  }

  handleTyreMotoSizeConfiguratorFilterOptionsAction(action) {
    this.dispatch({
      source: ACTION_TYPES.TYRE_MOTO_SIZE_CONFIGURATOR_FILTER_OPTIONS_ACTION,
      action,
    });
  }

  handleCatalogItemsAction(action) {
    this.dispatch({
      source: ACTION_TYPES.CATALOG_ITEMS_ACTION,
      action,
    });
  }

  handleNotifyMeAction(action) {
    this.dispatch({
      source: ACTION_TYPES.NOTIFY_ME_ACTION,
      action,
    });
  }

  handleCatalogFilterViewAction(action) {
    this.dispatch({
      source: ACTION_TYPES.CATALOG_FILTER_VIEW_ACTION,
      action,
    });
  }

  handleCatalogFilterLightboxViewAction(action) {
    this.dispatch({
      source: ACTION_TYPES.CATALOG_FILTER_LIGHTBOX_VIEW_ACTION,
      action,
    });
  }

  handleCatalogConditionalOptionsAction(action) {
    this.dispatch({
      source: ACTION_TYPES.CATALOG_CONDITIONAL_OPTIONS_ACTION,
      action,
    });
  }

  handleCatalogMobileFilterVisibilityAction(action) {
    this.dispatch({
      source: ACTION_TYPES.CATALOG_MOBILE_FILTER_VISIBILITY_ACTION,
      action,
    });
  }

  handleCatalogFilterExplicitImplicitApplyAction(action) {
    this.dispatch({
      source: ACTION_TYPES.CATALOG_FILTER_EXPLICIT_IMPLICIT_APPLY,
      action,
    });
  }

  handleCatalogFilterProvisionalStateAction(action) {
    this.dispatch({
      source: ACTION_TYPES.CATALOG_FILTER_PROVISIONAL_STATE,
      action,
    });
  }

  handleCatalogSortingAction(action) {
    this.dispatch({
      source: ACTION_TYPES.CATALOG_SORTING_ACTION,
      action,
    });
  }

  handleCatalogPromotionsAction(action) {
    this.dispatch({
      source: ACTION_TYPES.CATALOG_PROMOTIONS_ACTION,
      action,
    });
  }

  handleCatalogAdsAction(action) {
    this.dispatch({
      source: ACTION_TYPES.CATALOG_ADS_ACTION,
      action,
    });
  }

  handleFilterAvailableOptionsAction(action) {
    this.dispatch({
      source: ACTION_TYPES.FILTER_AVAILBALE_OPTIONS_ACTION,
      action,
    });
  }

  handleCatalogShowDetailsAction(action) {
    this.dispatch({
      source: ACTION_TYPES.CATALOG_SHOW_DETAILS_ACTION,
      action,
    });
  }

  handleUiLockAction(action) {
    this.dispatch({
      source: ACTION_TYPES.UI_LOCK_ACTION,
      action,
    });
  }
  handleLightboxUiLockAction(action) {
    this.dispatch({
      source: ACTION_TYPES.LIGHTBOX_UI_LOCK_ACTION,
      action,
    });
  }
  handleTyreIndexExplanationLightboxAction(action) {
    this.dispatch({
      source: ACTION_TYPES.TYRE_INDEX_EXPLANATION_LIGHTBOX_ACTION,
      action,
    });
  }
  handleCatalogPostcodeAction(action) {
    this.dispatch({
      source: ACTION_TYPES.CATALOG_POSTCODE_ACTION,
      action,
    });
  }

  handleWhereToFindTyreSizeLightBoxAction(action) {
    this.dispatch({
      source: ACTION_TYPES.WHERE_TO_FIND_TYRE_SIZE_LIGHT_BOX_ACTION,
      action,
    });
  }

  handleContactUsLightBoxAction(action) {
    this.dispatch({
      source: ACTION_TYPES.CONTACT_US_LIGHT_BOX_ACTION,
      action,
    });
  }

  handleFSFMotoLightboxAction(action) {
    this.dispatch({
      source: ACTION_TYPES.FSF_MOTO_LIGHTBOX_ACTION,
      action,
    });
  }

  handleFSFNotAvailableLightboxAction(action) {
    this.dispatch({
      source: ACTION_TYPES.FSF_NOT_AVAILABLE_LIGHTBOX_ACTION,
      action,
    });
  }

  handleFSHomePageLightboxAction(action) {
    this.dispatch({
      source: ACTION_TYPES.FS_HOME_PAGE_LIGHTBOX_ACTION,
      action,
    });
  }

  handleWheelAlignmentInfoLightboxAction(action) {
    this.dispatch({
      source: ACTION_TYPES.WHEEL_ALIGNMENT_INFO_LIGHTBOX_ACTION,
      action,
    });
  }

  
  handleSelectFSLightboxAction(action) {
    this.dispatch({
      source: ACTION_TYPES.SELECT_FS_LIGHTBOX_ACTION,
      action,
    });
  }
  
  handleFSRemoveLightboxAction(action) {
    this.dispatch({
      source: ACTION_TYPES.FS_REMOVE_LIGHTBOX_ACTION,
      action,
    });
  }


  handleCrossSellLightboxAction(action) {
    this.dispatch({
      source: ACTION_TYPES.CROSS_SELL_LIGHTBOX_ACTION,
      action,
    });
  }

  handleCrossSellRemoveLightboxAction(action) {
    this.dispatch({
      source: ACTION_TYPES.CROSS_SELL_REMOVE_LIGHTBOX_ACTION,
      action,
    });
  }
  
  handleVoucherCodeLightboxAction(action) {
    this.dispatch({
      source: ACTION_TYPES.VOUCHER_CODE_LIGHTBOX_ACTION,
      action,
    });
  }

  handleVehicleDetailsLightboxAction(action) {
    this.dispatch({
      source: ACTION_TYPES.VEHICLE_DETAILS_LIGHTBOX_ACTION,
      action,
    });
  }

  handleDriverReviewLightboxAction(action) {
    this.dispatch({
      source: ACTION_TYPES.DRIVER_REVIEW_LIGHTBOX_ACTION,
      action,
    });
  }

  handleImageLightboxAction(action) {
    this.dispatch({
      source: ACTION_TYPES.IMAGE_LIGHTBOX_ACTION,
      action,
    });
  }

  handlePaypalCreditCardFormAction(action) {
    this.dispatch({
      source: ACTION_TYPES.PAYPAL_CREDIT_CARD_FORM_ACTION,
      action,
    });
  }

  handleProductsAction(action) {
    this.dispatch({
      source: ACTION_TYPES.PRODUCTS_ACTION,
      action,
    });
  }
  
  handleCrossSellProductsAction(action) {
    this.dispatch({
      source: ACTION_TYPES.CROSS_SELL_PRODUCTS_ACTION,
      action,
    });
  }

  handleFriendbuyLightBoxAction(action) {
    this.dispatch({
      source: ACTION_TYPES.FRIENDBUY_LIGHT_BOX_ACTION,
      action,
    });
  }

  handleFreeMobilFittingLightBoxAction(action) {
    this.dispatch({
      source: ACTION_TYPES.FREE_MOBILE_FITTING_LIGHT_BOX_ACTION,
      action,
    });
  }

  handleCustomerRedirectLightBoxAction(action) {
    this.dispatch({
      source: ACTION_TYPES.CUSTOMER_REDIRECT_LIGHT_BOX_ACTION,
      action,
    });
  }

  handleSidebarAction(action) {
    this.dispatch({
      source: ACTION_TYPES.SIDEBAR_ACTION,
      action,
    });
  }

  handleOrderTrackingShowAddressFormAction(action) {
    this.dispatch({
      source: ACTION_TYPES.ORDER_TRACKING_SHOW_ADDRESS_FORM_ACTION,
      action,
    });
  }

  handleLastUsedConfiguratorAction(action) {
    this.dispatch({
      source: ACTION_TYPES.LAST_USED_CONFIGURATOR,
      action,
    });
  }

  handleOlaHomePageLightboxAction(action) {
    this.dispatch({
      source: ACTION_TYPES.OLA_HOME_PAGE_LIGHTBOX_ACTION,
      action,
    });
  }

  handleShippingAction(action) {
    this.dispatch({
      source: ACTION_TYPES.SHIPPING_ACTION,
      action,
    });
  }

  handleCatalogDeliveryInfoLightBoxAction(action) {
    this.dispatch({
      source: ACTION_TYPES.CATALOG_DELIVERY_INFO_LIGHT_BOX_ACTION,
      action,
    });
  }

  handleInfoLightBoxAction(action) {
    this.dispatch({
      source: ACTION_TYPES.INFO_LIGHT_BOX_ACTION,
      action,
    });
  }

  handleInfoPopupAction(action) {
    this.dispatch({
      source: ACTION_TYPES.INFO_POPUP_ACTION,
      action,
    });
  }

  handleHttpRequestAction(action) {
    this.dispatch({
      source: ACTION_TYPES.HTTP_REQUEST_ACTION,
      action,
    });
  }

  handleActiveProductAction(action) {
    this.dispatch({
      source: ACTION_TYPES.ACTIVE_PRODUCT_ACTION,
      action,
    });
  }

  handleProductBatchStocksAction(action) {
    this.dispatch({
      source: ACTION_TYPES.PRODUCT_BATCH_STOCKS_ACTION,
      action,
    });
  }

  handleProductMixedStocksComputeAction(action) {
    this.dispatch({
      source: ACTION_TYPES.PRODUCT_MIXED_STOCKS_COMPUTE_ACTION,
      action,
    });
  }

  handleProductMixedStocksLightboxAction(action) {
    this.dispatch({
      source: ACTION_TYPES.PRODUCT_MIXED_STOCKS_LIGHTBOX_ACTION,
      action,
    });
  }

  handleBillingAddressAction(action) {
    this.dispatch({
      source: ACTION_TYPES.BILLING_ADDRESS_ACTION,
      action,
    });
  }

  handleShippingAddressAction(action) {
    this.dispatch({
      source: ACTION_TYPES.SHIPPING_ADDRESS_ACTION,
      action,
    });
  }

  handleCmsLightboxAction(action) {
    this.dispatch({
      source: ACTION_TYPES.CMS_LIGHTBOX_ACTION,
      action,
    });
  }

  handleFsAppointmentAction(action) {
    this.dispatch({
      source: ACTION_TYPES.FS_APPOINTMENT_ACTION,
      action,
    });
  }

  handleFsAppointmentDetailsAction(action) {
    this.dispatch({
      source: ACTION_TYPES.FS_APPOINTMENT_DETAILS_ACTION,
      action,
    });
  }

  handleServicesFormAction(action) {
    this.dispatch({
      source: ACTION_TYPES.SERVICES_FORM_ACTION,
      action,
    });
  }
}

const Dispatcher = new DispatcherClass();
export default Dispatcher;
